// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import authReducer from "./auth/authReducer"
import personReducer from "./person/personReducer"
import adminReducer from "./admin/adminReducer"
import legalReducer from "./legal/legalReducer"
import dashboardReducer from "./dashboard/dashboardReducer"
import comportamientoPagoReducer from "./comportamientoPago/comportamientoPagoReducer"

const rootReducer = combineReducers({
  navbar,
  layout,
  authReducer,
  personReducer,
  adminReducer,
  legalReducer,
  dashboardReducer,
  comportamientoPagoReducer
})

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer
